interface FrontendErrorContext {
  context?: string;
  componentStack?: string;
  tenantId?: string;
}

const MAX_MESSAGE_LENGTH = 1000;
const MAX_STACK_LENGTH = 4000;

/** Best-effort reporting for render and asynchronous frontend failures. */
export function reportFrontendError(error: unknown, details: FrontendErrorContext = {}): void {
  const normalized = error instanceof Error ? error : new Error(String(error));
  const safeUrl = `${window.location.origin}${window.location.pathname}`;

  try {
    void fetch("/api/v1/monitoring/frontend-error", {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        error_message: normalized.message.slice(0, MAX_MESSAGE_LENGTH),
        stack_trace: (normalized.stack ?? "").slice(0, MAX_STACK_LENGTH),
        component_stack: (details.componentStack ?? "").slice(0, MAX_STACK_LENGTH),
        // Query strings and fragments may contain OAuth codes or user-entered
        // searches, so only report the origin and pathname.
        url: safeUrl,
        timestamp: new Date().toISOString(),
        tenant_id: details.tenantId,
        context: details.context,
      }),
    }).catch(() => {
      // Monitoring must never create another user-facing failure.
    });
  } catch {
    // Best-effort only (for example, fetch may be unavailable during teardown).
  }
}
